import { TimePicker, type TimePickerProps } from "antd"
import dayjs, { type Dayjs } from "dayjs"
import React, { useState } from "react"

interface CalendarTimePickerProps extends Omit<TimePickerProps, "onChange"> {
  onChange?: (value: Dayjs | null) => void
}

export function CustomTimePicker({
  onChange,
  ...props
}: CalendarTimePickerProps) {
  const [open, setOpen] = useState(false)

  const handleChange: TimePickerProps["onChange"] = (date) => {
    if (!date) {
      onChange?.(null)
      return
    }

    // Normalize the time — we take only hours and minutes
    const normalized = dayjs()
      .tz()
      .hour(date.hour())
      .minute(date.minute())
      .second(0)
      .millisecond(0)

    onChange?.(normalized)
  }

  return (
    <TimePicker
      // The scheduling standard, shared by the Calendar and the Lead forms so
      // the two cannot drift: a 12-hour clock in quarter-hour steps. A caller
      // that genuinely needs something else still overrides it.
      format={"h:mm A"}
      minuteStep={15}
      use12Hours
      {...props}
      open={open}
      onOpenChange={setOpen}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (open && e.key === "Enter") {
          e.preventDefault()
          e.stopPropagation()
          setOpen(false)
        }
      }}
    />
  )
}
